import config from '@/api/config';

const logAnalyticsEvent = (eventName, payload, isDefault = false) => {
    console.log(`ANALYTIC:\n 1.eventName: ${eventName}\nisDefault: ${isDefault}\n2.parameters:`, payload)

    try {
        if (isDefault) {
            if (!config.isDev) {
                window.fbq('track', eventName);
            }
        } else {
            if (!config.isDev) {
                if (payload) {
                    window.fbq('trackCustom', eventName, payload);
                    window.gtag('event', eventName, payload);
                    window.ym(62052514, 'reachGoal', eventName);
                } else {
                    window.fbq('trackCustom', eventName);
                    window.gtag('event', eventName, payload);
                    window.ym(62052514, 'reachGoal', eventName);
                }
            }
        }
    } catch (e) {
        console.log('analytics error:', e)
    }
}
const errorLogger = (eventName, message, sendEventToAnalytics = true) => {
    console.log(`LOG ERROR:\n 1.eventName: ${eventName}\nmessage: ${message}`)
    try {
        let payload = {
            'description': `${eventName} | ${message}`,
            'fatal': false,
        }
        window.fbq('trackCustom', 'exception', payload);
        window.gtag('event', 'exception', payload);
        if (sendEventToAnalytics) {
            logAnalyticsEvent(eventName)
        }
    } catch (e) {
        console.log('analytics error logger error:', e)
    }
}
const pageViewLogger = (title, location, path) => {
    console.log(`LOG PAGE VIEW:\n 1.title: ${title}\nlocation: ${location} path: ${path}`)
    try {
        window.gtag('event', 'page_view', {
            page_title: title,
            page_location: location,
            page_path: path
        })
    } catch (e) {
        console.log('analytics page view logger error:', e)
    }
}

export default logAnalyticsEvent
export const logError = errorLogger
export const logPageView = pageViewLogger